export default __webpack_public_path__ + "static/media/twitter.b16c02d4.svg";